import { createRouter, createWebHashHistory } from 'vue-router'
import { jurisdiction } from '@/api/shopping.js'
import { LayoutRoutes } from '../pages/Layout/Layout.js'
const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('../pages/home/index.vue')
	},
	{
		path: '/wiki',
		name: 'Wiki',
		component: () => import('../pages/wiki/index.vue')
	},
	{
		path: '/quotation',
		name: 'Quotation',
		component: () => import('../pages/quotation/index.vue')
	},
	...LayoutRoutes,
	// {
	// 	path: '/shopping',
	// 	name: 'shopping',
	// 	component: () => import('../pages/shopping/index.vue')
	// },
	// {
	// 	path: '/goodsdetail',
	// 	name: 'goodsdetail',
	// 	component: () => import('../pages/shopping/goods.vue')
	// },
	// {
	// 	path: '/cart',
	// 	name: 'cart',
	// 	component: () => import('../pages/shopping/cart.vue')
	// },
	// {
	// 	path: '/settle',
	// 	name: 'settle',
	// 	component: () => import('../pages/shopping/settle.vue')
	// },
	{
		path: '/goods',
		name: 'Goods',
		component: () => import('../pages/demo8/goods.vue')
	},
	{
		path: '/layout',
		name: 'Layout',
		component: () => import('../pages/demo8/layout.vue')
	},
	{
		path: '/factory',
		name: 'Factory',
		component: () => import('../pages/factory/index.vue')
	},
	{
		path: '/factory2',
		name: 'Factory2',
		component: () => import('../pages/factory/indexx.vue')
	},
	{
		path: '/view',
		name: 'View',
		component: () => import('../pages/view/index.vue')
	},
	{
		path: '/chart',
		name: 'Chart',
		component: () => import('../pages/demo8/table.vue')
	},
	{
	  path: '/login',
	  name: 'Login',
	  component: () => import('../pages/login/index.vue')
	},
	{
		path: '/module',
		name: 'Module',
		component: () => import('../pages/module/index.vue'),
		redirect: '/node',
		children: [
			{
				path: '/node',
				name: 'Node',
				component: () => import('../pages/node/index.vue')
			},
			/* {
				path: '/batch_add',
				component: () => import('../pages/node/batch_add.vue')
			}, */
			{
				path: '/todo',
				name: 'Todo',
				component: () => import('../pages/todo/index.vue')
			},
		]
	},
	{
		path: '/meta',
		name: 'Meta',
		component: () => import('../pages/meta/index.vue')
	},
	{
	  path: '/system',
	  name: 'System',
	  component: () => import('../pages/system/index.vue'),
	  children: [
		  {
			path: 'modules',
			component: () => import('../pages/system/modules.vue')
		  },
		  {
		  	path: 'model',
		  	component: () => import('../pages/system/model.vue')
		  },
		  {
		  	path: 'modelexpand',
		  	component: () => import('../pages/system/modelExpand.vue')
		  },
		  {
		  	path: 'dict',
		  	component: () => import('../pages/system/dict.vue')
		  },
		  {
		  	path: 'config',
		  	component: () => import('../pages/system/config.vue')
		  },
		  {
		  	path: 'factory',
		  	component: () => import('../pages/system/factory.vue')
		  },
		  {
		  	path: 'task',
		  	component: () => import('../pages/system/task.vue')
		  },
		  {
		  	path: 'dept',
		  	component: () => import('../pages/system/dept.vue')
		  },
		  {
			  path: 'plugin',
			  component: () => import('../pages/system/plugin.vue')
		  },
		  {
			  path: 'spider',
			  component: () => import('../pages/system/spider.vue')
		  },
		  {
			  path: 'log',
			  component: () => import('../pages/system/log.vue')
		  }
	  ]
	},
	{
	  path: '/mobile',
	  name: 'Mobile',
	  component: () => import('../pages/mobile/index.vue'),
	  children: [
		  {
			path: 'signature',
			component: () => import('../pages/mobile/signature.vue')
		  },
		  {
			path: 'video',
			component: () => import('../pages/mobile/video.vue')
		  },
		  {
			path: 'file',
			component: () => import('../pages/mobile/file.vue')
		  },
		  {
			path: 'image',
			component: () => import('../pages/mobile/image.vue')
		  }
	  ]
	},
	{
		path: '/bbs',
		name: 'Bbs',
		component: () => import('../pages/bbs/index.vue'),
		children: [			{
				path: 'category',
				component: () => import('../pages/bbs/category.vue')
			},
			{
				path: 'topic',
				component: () => import('../pages/bbs/topic.vue')
			},
			{
				path: 'info',
				component: () => import('../pages/bbs/info.vue')
			},
		]
	},
	{
	  path: '/scrm',
	  name: 'scrm',
	  component: () => import('../pages/scrm/index.vue')
	}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router